import { useMutation, useQuery } from "@tanstack/react-query";
import { useAxios, useApiResponseParser } from "../";

export interface IMilestone {
    Id?: string;
    ProjectId: string;
    MilestoneKey: string;
    PlannedDate: string | Date | null;
    ActualDate: string | Date | null;
    Status: "PENDING" | "COMPLETED" | "DELAYED";
}

export default function useMilestone() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useListMilestones(ProjectId: string) {
        return useQuery({
            queryKey: ["milestones", ProjectId],
            queryFn: () => axiosPrivate.get(`/v1/project/milestones`, { params: { ProjectId } }).then(parseSuccessResponseData),
            enabled: !!ProjectId,
        });
    }

    function useUpsertMilestone() {
        return useMutation({
            mutationFn: (parameters: IMilestone) =>
                axiosPrivate.post(`/v1/project/milestones/upsert`, parameters).then(parseSuccessResponseData),
        });
    }

    return { useListMilestones, useUpsertMilestone };
}
